import React from "react"
import { Image } from "./Images"
import { useStaticQuery, graphql } from "gatsby"

export const BitcoinBg = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "btc-bg.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 990) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)
  return <Image data={data} />
}

export default BitcoinBg
